import React, { Component } from "react";
import { connect } from "react-redux";
import {
  updateUserDetails,
  updatePreviewPage,
  updatePdfLink,
  updateUserId,
  updateMotorTypeSelection,
  updateProductId,
  updateOrderCode,
  updateCountryList,
  clearStorage,
  validateMotorLayout,
  validateMotorType,
  validatePaintFinish,
  validateRotationDirection,
  validateWinchType
} from "../actions";
import {
  Button,
  FormGroup,
  Label,
  FormText,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import apiInstance from "../common/api.js";
import Select from "react-select";
import { formDigCode } from "../common/formDigCode";

class GenerateDataSheet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: "",
      showGuidelines: false,
      acceptGuidelines: false,
      acceptNewsLetter: true
    };
    this.handleOnClick = this.handleOnClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.showGuidelines = this.showGuidelines.bind(this);
    this.acceptGuidelines = this.acceptGuidelines.bind(this);
    this.acceptNewsLetter = this.acceptNewsLetter.bind(this);
  }

  formActualOrderCode(propValue) {
    var oCode;
    oCode =
      "3.TI." +
      propValue.winchType.orderCode +
      "." +
      propValue.drumWidth.orderCode +
      "." +
      propValue.drumSurface.orderCode +
      "." +
      propValue.motorType.orderCode +
      "." +
      propValue.rotationDirection.orderCode +
      "." +
      propValue.motorLayout.orderCode +
      "." +
      (propValue.ropeEndControl.orderCode !== "00"
        ? propValue.ropeEndControl.orderCode
        : propValue.pressureRoller.orderCode) +
      "." +
      propValue.loadMeasuring.orderCode +
      "." +
      propValue.paintFinish.orderCode +
      "." +
      propValue.wireRope.orderCode +
      "." +
      formDigCode(propValue) +
      ".";
    return oCode;
  }

  handleOnClick() {
    if (this.props.winchType === "") {
      this.props.validateWinchType(false);
    }
    if (this.props.motorType === "") {
      this.props.validateMotorType(false);
    }
    if (this.props.rotationDirection === "") {
      this.props.validateRotationDirection(false);
    }
    if (this.props.motorLayout === "") {
      this.props.validateMotorLayout(false);
    }
    if (this.props.paintFinish === "") {
      this.props.validatePaintFinish(false);
    }
    if (
      this.props.winchType === "" ||
      this.props.motorType === "" ||
      this.props.rotationDirection === "" ||
      this.props.motorLayout === "" ||
      this.props.paintFinish === ""
    ) {
      alert(
        "It seems one or more items are not selected in the form. Please see the form again and complete."
      );
    } else if (this.props.loadMeasuring.main && !this.props.loadMeasuring.sub) {
      alert("Load measuring needs the cable to be selected as well");
    } else {
      apiInstance.get("/fetchAllCountries").then(res => {
        this.props.onGettingCountryList(res.data);
        this.setState({
          showModal: "show"
        });
        var actualOrderCodeFormed = this.formActualOrderCode(this.props);
        this.props.onOrderCodeFormed(actualOrderCodeFormed);
      });
    }
  }

  submitForm(formData) {
    document.getElementsByTagName("meta")["viewport"].content =
      "width=device-width, initial-scale=1, maximum-scale=0";
    var motorTypeUpdate = {
      ...this.props.motorType,
      hydraulicPressure: {
        ...this.props.motorType.hydraulicPressure,
        value: this.props.motorType.hydraulicPressure.enteredValue
          ? this.props.motorType.hydraulicPressure.enteredValue
          : this.props.motorType.hydraulicPressure.value
      },
      hoistingForce: {
        ...this.props.motorType.hoistingForce,
        value: this.props.motorType.hoistingForce.calcHoistingForce
          ? this.props.motorType.hoistingForce.calcHoistingForce
          : this.props.motorType.hoistingForce.value
      },
      oilFlow: {
        ...this.props.motorType.oilFlow,
        value: this.props.motorType.oilFlow.enteredValue
          ? this.props.motorType.oilFlow.enteredValue
          : this.props.motorType.oilFlow.value
      },
      ropeSpeed: {
        ...this.props.motorType.ropeSpeed,
        value: this.props.motorType.ropeSpeed.calculatedRopeSpeed
          ? this.props.motorType.ropeSpeed.calculatedRopeSpeed
          : this.props.motorType.ropeSpeed.value
      }
    };
    this.props.updateMotorType(motorTypeUpdate);
    this.props.onUserDetails(formData);
    localStorage.setItem("firstName", this.props.userDetails.firstName);
    localStorage.setItem("lastName", this.props.userDetails.lastName);
    localStorage.setItem("company", this.props.userDetails.company);
    localStorage.setItem("country", JSON.stringify(formData.country));
    localStorage.setItem("email", this.props.userDetails.email);

    var productData = {};
    var motorCode = "";
    var pressureRollerCode = "";
    var mcdCode = "";
    var rotationCode = this.props.rotationDirection.orderCode;
    if (
      this.props.winchType.orderCode === "01" ||
      this.props.winchType.orderCode === "02"
    ) {
      motorCode = "XXXXX";
    } else if (
      (this.props.winchType.orderCode === "04" ||
        this.props.winchType.orderCode === "05") &&
      (this.props.motorType.orderCode === "GM085" ||
        this.props.motorType.orderCode === "GM064" ||
        this.props.motorType.orderCode === "GM107")
    ) {
      motorCode = "GMXXX";
    } else if (
      (this.props.winchType.orderCode === "04" ||
        this.props.winchType.orderCode === "05") &&
      this.props.motorType.orderCode === "PM049"
    ) {
      motorCode = "PMXXX";
    }
    if (
      this.props.pressureRoller.orderCode === "10" &&
      this.props.ropeEndControl.orderCode === "00"
    ) {
      pressureRollerCode = "10";
      mcdCode = "00";
    } else if (this.props.pressureRoller.orderCode === "00") {
      pressureRollerCode = "00";
      mcdCode = "00";
      rotationCode = "X";
    } else {
      pressureRollerCode = this.props.ropeEndControl.orderCode;
      mcdCode = this.props.loadMeasuring.orderCodeForPdf
        ? this.props.loadMeasuring.orderCodeForPdf
        : "00";
    }
    var orderCodeFormed =
      this.props.winchType.orderCode +
      "." +
      this.props.drumWidth.orderCode +
      "." +
      this.props.drumSurface.orderCode +
      "." +
      motorCode +
      "." +
      rotationCode +
      ".X." +
      pressureRollerCode +
      "." +
      mcdCode +
      ".";

    var actualOrderCode = this.formActualOrderCode(this.props);
    var weightApprox = this.addAllWeight(this.props);
    productData.orderCode = orderCodeFormed;
    productData.actualOrderCode = actualOrderCode;
    productData.product = this.props;
    productData.user = this.props.userDetails;
    productData.subscribed = this.state.acceptNewsLetter
      ? "subscribed"
      : "unsubscribed";
    weightApprox = Math.round(weightApprox * 100) / 100;
    if (this.props.mType === "metric") {
      productData.weightApprox = weightApprox.toString().replace(".", ",");
    } else {
      productData.weightApprox = weightApprox;
    }
    productData.api2c = this.props.api2c;

    apiInstance.post("/add_data", productData).then(res => {
      this.props.onGettingResponse(res.data.previewHtml);
      this.props.onGettingPdfUrl(res.data.filename);
      this.props.onGettingUserId(res.data.userid);
      this.props.onGettingProductId(res.data.productid);
    });
  }

  addAllWeight(propWeight) {
    var totalWeight =
      propWeight.drumWidth.weight +
      propWeight.drumSurface.weight +
      propWeight.motorType.weight +
      propWeight.pressureRoller.weight +
      propWeight.ropeEndControl.weight +
      propWeight.loadMeasuring.weight +
      propWeight.wireRope.weight +
      propWeight.externalBrakeRelease.weight;

    return totalWeight;
  }

  closeModal() {
    this.setState({
      showModal: false,
      showGuidelines: false
    });
  }

  acceptGuidelines(e) {
    this.setState({
      acceptGuidelines: !this.state.acceptGuidelines
    });
  }

  showGuidelines(e) {
    this.setState({
      showGuidelines: !this.state.showGuidelines
    });
  }

  acceptNewsLetter(e) {
    this.setState({
      acceptNewsLetter: !this.state.acceptNewsLetter
    });
  }

  render() {
    var storeData = this.props;

    return (
      <div className="btn-wrapper">
        <div className="pb-20">
          <label>
            <input type="checkbox" onChange={this.acceptGuidelines} /> I accept
            the ROTZLER data protection{" "}
          </label>{" "}
          <a className="guidelines" onClick={this.showGuidelines}>
            guidelines.
          </a>
        </div>
        <div className="pb-20">
          <label>
            <input type="checkbox" onChange={this.acceptNewsLetter} /> I do not
            want any e-mail marketing from ROTZLER
          </label>{" "}
        </div>
        <button
          className="btn generate-btn"
          onClick={this.handleOnClick}
          disabled={!this.state.acceptGuidelines}
        >
          Generate Data Sheet
        </button>
        {this.state.showGuidelines && (
          <GuideLineModalContent toggle={this.closeModal} />
        )}
        {this.state.showModal && (
          <ModalContent
            countryList={this.props.countryList}
            toggle={this.closeModal}
            storeData={storeData}
            orderCode={this.formActualOrderCode(this.props)}
            dispatchFunction={formData => {
              this.submitForm(formData);
            }}
          />
        )}
      </div>
    );
  }
}

class GuideLineModalContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
    if (this.state.modal) {
      this.props.toggle();
    }
  }

  render() {
    return (
      <Modal isOpen={this.state.modal} toggle={this.toggle}>
        <ModalHeader toggle={this.toggle}>
          <h5 className="modal-title" id="modaltitle">
            Data Protection Information
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>
          <p>
            ROTZLER HOLDING GmbH + Co. KG and its subsidiaries thank you for
            visiting this website and showing an interest in our company and its
            products and services. We respect your privacy. We therefore attach
            great importance to and gear our business processes to protecting
            your privacy when processing personal data as well as ensuring the
            security of all business data.
          </p>
          <p>
            The protection of your personal data is of particular importance to
            us. For this reason we process your personal data exclusively
            pursuant to current legal regulations.
          </p>
          <h6>Purpose and Responsibility</h6>
          <p>
            This privacy protection statement provides details of the nature,
            extent and purpose of collecting and using data as well as using
            cookies within the websites of Rotzler Holding GmbH & Co.KG, Postbox
            1165, 79577 Steinen, Robert-Bosch-Str. 4, 79585 Steinen, Germany
            http://www.rotzler.de/en/company/legal-notice/, as responsible for
            data protection (hereinafter referred to as „Rotzler") You can
            contact the data protection officer, who is responsible for
            processing the data under following address:
          </p>
          <p>
            ROTZLER HOLDING GmbH + Co. KG
            <br />
            Data Protection Officer
            <br />
            Robert-Bosch-Str. 4<br />
            79585 Steinen
            <br />
            Germany
          </p>
          <p>
            or via out contact form
            <a href="http://contacts.rotzler.com/en/contact/locations/"> 
              {" "}contacts.rotzler.com/en/contact/locations.
            </a>
          </p>
          <p>
            Any data subject may - at any time - contact the data protection
            officer directly for questions and suggestions in regard of data
            protection.
          </p>
          <h6>Collection, processing and use of personal data</h6>
          <p>
            Personal data are all data, personally referring to you, e.g. name,
            address, email-address, phone no. & user behavior. Personal data the
            users provide will be used for the following purposes:
          </p>
          <ul>
            <li>
              The execution of our services, service activities and user
              benefits when visiting our website
            </li>
            <li>
              To ensure an effective customer service and technical support
            </li>
            <li>
              Technical and commercial information regarding our quotations
            </li>
          </ul>
          <p>
            We only transfer the data to third parties after your explicit
            consent or for accounting purposes (e.g. banking transactions or
            postal invoice dispatch) or if it is necessary to fulfill our
            contractual obligations towards the users. Basically, all personal
            data is stored for fulfillment of the purpose or according to legal
            retention requirements.
          </p>
          <h6>Collection personal data by using the contact form</h6>
          <p>
            When contacting us by using the contact form, all entered data is
            stored (your email-address, your name, company affiliation and if
            necessary phone no.) for the purpose of answering your questions.
          </p>
          <h6>Collection personal data for rotzler.de</h6>
          <p>
            If you use our website only for information purposes, i.e. if you do
            not use a contact form or transmit information to us in any other
            way, we only collect the personal data, which are transmitted from
            your browser to our server. If you want to view our website, we
            collect following data, which are technically necessary for us to
            provide access to our website and to ensure stability and security.
          </p>
          <p>
            (Legal basis is Article 6 paragraph 1 sentence 1 lit. f DS-GVO)
            e.g.:
          </p>
          <ul>
            <li>Name of the accessed website</li>
            <li>IP-address</li>
            <li>Date and time of the access</li>
            <li>Time zone difference to Greenwich Mean Time (GMT)</li>
            <li>Requesting provider</li>
            <li>Notification of successful access</li>
            <li>Content of the request (specific page)</li>
            <li>Access status/HTTP status code</li>
            <li>Amount of transferred data</li>
            <li>Previously visited page (Referrer URL)</li>
            <li>Browser type and version </li>
            <li>The operating system of the user</li>
          </ul>
          <p>
            We use this log data without assignment to the person of the user or
            other profiling according to statutory regulations only for
            statistical evaluations for the purpose of operation, security and
            optimization of our offer. However, we reserve the right to
            retrospectively check the log data if, on the basis of concrete
            evidence, the legitimate suspicion of unlawful use exists. We delete
            the so-called „server log files" after 3 months, or restrict the
            processing in the case that a legal retention period exists.
          </p>
          <h6>Use of Cookies</h6>
          <p>
            Cookies are small units of information which are transmitted from
            our webserver to your web browser and are saved there to be
            retrieved later. We use cookies to make our offer user-friendly,
            effective and more secure. Cookies are small text files which are
            stored on your computer and saved by your browser.
          </p>
          <p>
            Cookies on our website do not collect any personal data of any kind.
            It is possible to visit our website when you exclude cookies. If you
            do not want that cookies are stored on your computer, we kindly ask
            you to disable this option in your settings of your browser. Stored
            cookies can be deleted in the system settings of your computer.
            Exclusion of cookies may lead to limited function of this website.
            It is also possible to manage many cookie settings of companies
            through US American website www.aboutads.info/choices/ or EU website
            www.youronlinechoices.com/uk/your-ad-choices.
          </p>
          <h6>Analytical Services</h6>
          <h6>Matomo (formerly Piwik)</h6>
          <p>
            This website uses web analytics service Piwik to continuously
            analyze and optimize the use of our website. With the obtained
            statistics we can improve our offer and make the offer more
            attractive for the user. Legal basis for the use of Piwik is Article
            6 paragraph 1 sentence 1 lit f DS-GVO.
          </p>
          <p>
            For evaluation purposes cookies are stored on the user's computer.
            The collected information will be stored exclusively on the
            provider's server in [Germany]. You can stop the evaluation by
            deleting of existing cookies and prevention of storage of cookies.
            If you prevent the storage of cookies we will inform you that this
            may lead to limited function of this website. You can prevent the
            storage of cookies by settings in your browser. You can object to
            the usage of Piwik by removing the check mark at the end of this
            website and thus activate the opt-out option.{" "}
          </p>
          <p>
            This website uses Piwik with the extension „AnonymizeIP" so that
            IP-addresses are only processed further in a shortened form to
            prevent them being directly linked to a particular individual. The
            IP address which is transferred to your browser by Piwik will not be
            merged with other data collected by us.
          </p>
          <p>
            Piwik is an open source project. Third-party data protection
            information is available at: https://matomo.org/privacy-policy/
          </p>
          <h6>Handling of personal data collected outside our website</h6>
          <p>
            All additional personal data which is collected by regular email
            exchange, letters or other business contacts are subject to the same
            guidelines and regulations as the personal data which is processed
            via our website.
          </p>
          <h6>Rights of users</h6>
          <p>
            According to EU Data Protection Regulation you have the following
            rights:
          </p>
          <p>
            To ask for information regarding categories of processed data,
            processing purpose, any recipients of the data, planned storage
            period (Art. 15 DSGVO);
          </p>
          <p>
            To ask for correction or rather addition of incorrect or incomplete
            data (Art. 16 DSGVO);To revoke any permission at any time with
            effect for the future (Art. 7 Abs. 3 DSGVO);
          </p>
          <p>
            To ask for deletion of data in certain cases in respect of Art. 17
            DSGVO - especially if data are no longer necessary for the intended
            use or are unlawfully processed or you revoke your consent (see
            above) or you have raised objection (acc. to above);
          </p>
          <p>
            To ask for limitation of data under certain conditions, if deletion
            is not possible or the obligation of deletion is in dispute (Art. 18
            DSGVO);
          </p>
          <p>
            Right to data portability, i.e. to request and obtain data, which
            you have provided to us, in a common machine-readable format as e.g.
            CSV and, optionally transmit them to others (Art. 20 DSGVO)
          </p>
          <p>
            To complain to the appropriate data protection authority about the
            data processing activities
          </p>
          <p>
            All information, requests for deletion and correction, requests to
            provide information, requests in regard of data portability or
            objections to data processing, please address by mail to:
          </p>
          <p>
            ROTZLER HOLDING GmbH + Co. KG
            <br />
            Data Protection Officer
            <br />
            Robert-Bosch-Str. 4<br />
            79585 Steinen
            <br />
            Germany
          </p>
          <p>
            or via our contact form{" "}
            <a href="http://contacts.rotzler.com/en/contact/locations/">
              contacts.rotzler.com/en/contact/locations/.
            </a>
          </p>
          <p>
            If you consider that the data processing violates the data
            protection law or infringes your data protection rights in any kind,
            you can file a complaint with the appropriate data protection
            authority.{" "}
          </p>
          <h6>Transmission of data to third countries</h6>
          <p>
            Data is exclusively transmitted to third countries to fulfill
            contractual obligations. This is made only within the Rotzler group
            and on basis of the EU Standard Contractual Clauses.
          </p>
          <h6>Data Security</h6>
          <p>
            We use current technical and organizational measures to protect data
            processing, especially for protection of your personal data during
            data transmission as well as for protection from unauthorized
            obtaining of knowledge by third parties.
          </p>
          <p>
            These measures will be adapted to the latest technical standard, the
            protection needs of personal data and risks to the rights and
            freedoms of data subjects.
          </p>
          <h6>Changes to this privacy protection statement</h6>
          <p>
            We reserve the right to change this Privacy Policy in order to adapt
            it to changing legal situations, or to changes in the service as
            well as data processing. Users are requested to inform themselves
            regularly about the content of the privacy policy, especially when
            they provide any new personally identifiable information.
          </p>
          <p>Update of Privacy Policy Statement: May 2018</p>
        </ModalBody>
      </Modal>
    );
  }
}

class ModalContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
    if (this.state.modal) {
      this.props.toggle();
    }
  }

  render() {
    return (
      <Modal isOpen={this.state.modal} toggle={this.toggle}>
        <ModalHeader toggle={this.toggle}>
          Please enter your details
        </ModalHeader>
        <ModalBody>
          <p className="orderCodeDisplay">
            The order code for your configuration is{" "}
            <span>{this.props.orderCode}</span>{" "}
          </p>
          <Userform
            countryList={this.props.countryList}
            storeDataFromModal={this.props.storeData}
            dispatch={formData => {
              this.props.dispatchFunction(formData);
            }}
          />
        </ModalBody>
      </Modal>
    );
  }
}

const formElement = ({
  errors,
  values,
  touched,
  isSubmitting,
  setFieldValue
}) => (
  <Form>
    <FormGroup>
      <Label for="name">First name</Label>
      <Field
        className="form-control"
        type="text"
        name="firstName"
        placeholder="First name"
      />
      {touched.firstName && errors.firstName && (
        <FormText>{errors.firstName}</FormText>
      )}
    </FormGroup>
    <FormGroup>
      <Label for="name">Last name</Label>
      <Field
        className="form-control"
        type="text"
        name="lastName"
        placeholder="Last name"
      />
      {touched.lastName && errors.lastName && (
        <FormText>{errors.lastName}</FormText>
      )}
    </FormGroup>
    <FormGroup>
      <Label for="company">Company</Label>
      <Field
        className="form-control"
        type="text"
        name="company"
        placeholder="Company"
      />
      {touched.company && errors.company && (
        <FormText>{errors.company}</FormText>
      )}
    </FormGroup>
    <FormGroup>
      <Label for="country">Country</Label>
      <CustomSelect
        country={values.countryList}
        name="country"
        defaultValues={values.country}
        onChange={setFieldValue}
      />
      {touched.country && errors.country && (
        <FormText>{errors.country}</FormText>
      )}
    </FormGroup>
    <FormGroup>
      <Label for="email">Email</Label>
      <Field
        className="form-control"
        type="text"
        name="email"
        placeholder="Email"
      />
      {touched.email && errors.email && <FormText>{errors.email}</FormText>}
    </FormGroup>

    <ModalFooter>
      <Button disabled={isSubmitting} color="primary">
        {" "}
        Save{" "}
      </Button>
    </ModalFooter>
  </Form>
);

const Userform = withFormik({
  mapPropsToValues(countryList) {
    var user = {
      firstName: localStorage.getItem("firstName")
        ? localStorage.getItem("firstName")
        : "",
      lastName: localStorage.getItem("lastName")
        ? localStorage.getItem("lastName")
        : "",
      company: localStorage.getItem("company")
        ? localStorage.getItem("company")
        : "",
      country: localStorage.getItem("country")
        ? localStorage.getItem("country")
        : "",
      email: localStorage.getItem("email") ? localStorage.getItem("email") : ""
    };
    return {
      firstName: user.firstName,
      lastName: user.lastName,
      company: user.company,
      country: user.country ? JSON.parse(user.country) : "",
      email: user.email,
      countryList: countryList
    };
  },
  validationSchema: Yup.object().shape({
    firstName: Yup.string().required(),
    lastName: Yup.string().required(),
    company: Yup.string().required(),
    country: Yup.object()
      .nullable()
      .required("Country should be selected"),
    email: Yup.string()
      .email("Please enter a valid email")
      .required()
  }),
  handleSubmit(values, { props }) {
    props.dispatch({
      firstName: values.firstName,
      lastName: values.lastName,
      company: values.company,
      country: values.country,
      email: values.email
    });
  }
})(formElement);

const mapActionToProps = {
  onUserDetails: updateUserDetails,
  onGettingResponse: updatePreviewPage,
  onGettingPdfUrl: updatePdfLink,
  onGettingUserId: updateUserId,
  updateMotorType: updateMotorTypeSelection,
  onGettingProductId: updateProductId,
  onOrderCodeFormed: updateOrderCode,
  onGettingCountryList: updateCountryList,
  clearLocalStorage: clearStorage,
  validateMotorLayout: validateMotorLayout,
  validateMotorType: validateMotorType,
  validatePaintFinish: validatePaintFinish,
  validateRotationDirection: validateRotationDirection,
  validateWinchType: validateWinchType
};

const mapStateToProps = state => {
  return {
    winchType: state.winchType,
    mType: state.mType,
    drumWidth: state.drumWidth,
    drumSurface: state.drumSurface,
    motorType: state.motorType,
    rotationDirection: state.rotationDirection,
    motorLayout: state.motorLayout,
    pressureRoller: state.pressureRoller,
    ropeEndControl: state.ropeEndControl,
    loadMeasuring: state.loadMeasuring,
    paintFinish: state.paintFinish,
    wireRope: state.wireRope,
    fasteners: state.fasteners,
    externalBrakeRelease: state.externalBrakeRelease,
    throttleValve: state.throttleValve,
    userDetails: state.userDetails,
    countryList: state.countryList,
    cleared: state.cleared
  };
};

class CustomSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      removeSelected: true,
      disabled: false,
      value: this.props.defaultValues,
      rtl: false
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(value) {
    this.setState({ value });

    this.props.onChange("country", value);
  }
  render() {
    const { value } = this.state;
    return (
      <Select
        multi={false}
        onChange={this.handleChange}
        placeholder="Select country"
        value={value}
        options={this.props.country.countryList.map(e => {
          return {
            label: e.countryname,
            value: e.idcountry,
            region: e.region,
            countryname: e.countryname,
            id: e.idcountry
          };
        })}
      />
    );
  }
}

export default connect(mapStateToProps, mapActionToProps)(
  GenerateDataSheet,
  Userform,
  ModalContent
);




// WEBPACK FOOTER //
// ./src/components/generateDataSheet.js